'use client';

import { useFormContext } from 'react-hook-form';
import { useLanguage } from '../../../../../context/LanguageContext';
import { formatVatNumber, formatEmiratesId } from '../../../../../utils/validationUtils';

export default function SellerStep4AdditionalDetails() {
  const { register, formState, setValue } = useFormContext();
  const { errors, touchedFields, isSubmitted } = formState;
  const { translate } = useLanguage();

  const handleVatNumberChange = (e) => {
    const formatted = formatVatNumber(e.target.value);
    setValue('vatNumber', formatted, { shouldValidate: true });
  };

  console.log('SellerStep4 - All errors:', errors);
  console.log('SellerStep4 - vatNumber error:', errors.vatNumber);
  console.log('SellerStep4 - location error:', errors.location);
  console.log('SellerStep4 - idPassportNo error:', errors.idPassportNo);
  console.log('SellerStep4 - idExpiryDate error:', errors.idExpiryDate);

  return (
    <div className="space-y-6">
      <div className='text-center'>
        <h2 className="text-2xl font-boldtext-slate-700 mb-2">
          {translate("auth.signup.additionalDetails")}
        </h2>
        <p className="text-white">
          {translate("auth.signup.provideIdentificationBusiness")}
        </p>
      </div>

      <div className="space-y-4">
        <div>
          <label htmlFor="location" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.location")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('location')}
            id="location"
            type="text"
            placeholder={translate("auth.signup.locationPlaceholder")}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.location || isSubmitted) && errors.location && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.location.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="vatNumber" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.vatNumber")}
          </label>
          <input
            {...register('vatNumber')}
            id="vatNumber"
            type="text"
            maxLength={15}
            placeholder={translate("auth.signup.vatNumberPlaceholder")}
            onChange={handleVatNumberChange}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />

          {(touchedFields.vatNumber || isSubmitted) && errors.vatNumber && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.vatNumber.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="emiratesIdNumber" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.emiratesIdNumber")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('emiratesIdNumber')}
            id="emiratesIdNumber"
            type="text"
            placeholder={translate("auth.signup.identificationNumberPlaceholder")}
            maxLength={18}
            onChange={(e) => {
              const formatted = formatEmiratesId(e.target.value);
              setValue('emiratesIdNumber', formatted, { shouldValidate: true });
            }}
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all"
          />
          {(touchedFields.emiratesIdNumber || isSubmitted) && errors.emiratesIdNumber && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.emiratesIdNumber.message)}
            </p>
          )}
        </div>

        <div>
          <label htmlFor="idExpiryDate" className="block text-sm font-medium text-white mb-2">
            {translate("auth.signup.idExpiryDate")} <span className="text-red-500">*</span>
          </label>
          <input
            {...register('idExpiryDate')}
            id="idExpiryDate"
            type="date"
            className="w-full px-4 py-3 bg-gray-900 border border-gray-600 rounded-lg text-white placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all
      [&::-webkit-calendar-picker-indicator]:invert [&::-webkit-calendar-picker-indicator]:brightness-0 [&::-webkit-calendar-picker-indicator]:invert-[1] [&::-webkit-calendar-picker-indicator]:filter"
          />
          {(touchedFields.idExpiryDate || isSubmitted) && errors.idExpiryDate && (
            <p className="text-red-500 text-sm mt-1">
              {String(errors.idExpiryDate.message)}
            </p>
          )}
        </div>
      </div>
    </div>
  );
}
